import { Zap, MapPin, ShieldCheck, BadgeCheck, ArrowUpRight } from "lucide-react";
import { SERVICES_BG } from "../../lib/troy";

const SERVICES = [
  {
    id: "rapidas",
    title: "Corridas rápidas",
    desc: "Resposta imediata pelo WhatsApp. Motorista a caminho em minutos.",
    icon: Zap,
    tone: "yellow",
    size: "lg:col-span-7 lg:row-span-2",
  },
  {
    id: "bairros",
    title: "Atendimento em bairros",
    desc: "Cobrimos General Carneiro e regiões próximas com agilidade.",
    icon: MapPin,
    tone: "red",
    size: "lg:col-span-5",
  },
  {
    id: "seguro",
    title: "Transporte seguro",
    desc: "Veículos revisados, motoristas identificados, rota monitorada.",
    icon: ShieldCheck,
    tone: "white",
    size: "lg:col-span-5",
  },
  {
    id: "verificado",
    title: "Motoristas verificados",
    desc: "Cadastro checado, documento em dia, avaliação contínua.",
    icon: BadgeCheck,
    tone: "yellow",
    size: "lg:col-span-12",
  },
];

export default function Services() {
  return (
    <section
      id="servicos"
      data-testid="services-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div
        className="absolute inset-0 -z-10 opacity-20 bg-cover bg-center"
        style={{ backgroundImage: `url(${SERVICES_BG})` }}
      />
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-black via-[#0A0A0A] to-black" />

      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between gap-6 flex-wrap mb-12">
          <div>
            <p className="text-xs tracking-[0.25em] uppercase text-[#FFCC00] font-bold mb-3">
              O que oferecemos
            </p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-tight text-balance max-w-2xl">
              Serviços pensados pra quem{" "}
              <span className="text-[#FFCC00]">não pode esperar</span>.
            </h2>
          </div>
          <p className="max-w-md text-white/60">
            Do deslocamento curto no bairro à corrida urgente pra cidade — a
            Troy entrega.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12 gap-5">
          {SERVICES.map((s) => (
            <ServiceCard key={s.id} {...s} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ title, desc, icon: Icon, tone, size }) {
  const toneMap = {
    yellow: { bg: "bg-[#FFCC00]", text: "text-black", glow: "shadow-[0_0_40px_rgba(255,204,0,0.25)]" },
    red: { bg: "bg-[#FF3B30]", text: "text-white", glow: "shadow-[0_0_40px_rgba(255,59,48,0.25)]" },
    white: { bg: "bg-white", text: "text-black", glow: "" },
  };
  const t = toneMap[tone];
  return (
    <article
      data-testid={`service-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
      className={`group relative ${size || "lg:col-span-6"} md:col-span-6 bg-[#18181C] border border-[#FFCC00]/15 rounded-3xl p-7 md:p-10 overflow-hidden hover:border-[#FFCC00]/50 transition-all duration-300`}
    >
      <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-[#FFCC00]/5 group-hover:bg-[#FFCC00]/10 transition-colors" />
      <div className="relative flex flex-col h-full min-h-[220px]">
        <div className={`inline-flex items-center justify-center w-12 h-12 rounded-2xl ${t.bg} ${t.text} ${t.glow} mb-6`}>
          <Icon className="w-6 h-6" strokeWidth={2.2} />
        </div>
        <h3 className="font-display text-2xl md:text-3xl font-bold tracking-tight mb-2">
          {title}
        </h3>
        <p className="text-white/60 leading-relaxed max-w-md">{desc}</p>
        <div className="mt-auto pt-6 flex items-center gap-2 text-[#FFCC00] text-sm font-semibold">
          Disponível agora
          <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </div>
      </div>
    </article>
  );
}
